"use client";

import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { showLoading } from "react-global-loading";

import * as myApi from "../../Api";
import { toast } from "react-toastify";

const ConfirmEmailForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const changeButtonState = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  }

  const emailActivation = (event) => {
    event.preventDefault();
    showLoading(true);
    const formData = new FormData(event.currentTarget);

    const verifyData = {
      name: formData.get("name"),
      email: formData.get("email"),
      kode_registrasi: formData.get("kode_registrasi"),
    };

    myApi.post("/verify", verifyData).then((response) => {
      showLoading(false);
      if (response.data.result !== undefined) {
        toast("User Anda berhasil diaktivasi. Silahkan login.", { type: "success" });
        setTimeout(() => {
          navigate(myApi.loginPath)
        }, 1500);
      } else {
        toast(response.data.message, { type: "error" });
      }
    }).catch((error) => {
      showLoading(false)
      toast(error.message, { type: "error" });
      console.error(error);
    });
  };

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <form onSubmit={emailActivation} className="max-w-[550px] mx-auto">
        <div className="card bg-base-100 border-0 rounded-[10px] mb-4 text-center">
          <div className="card-body p-4">
            <div className="mb-3 mb-md-4">
              <img
                src="/images/ejavec/ejavec-logo.svg"
                alt="logo"
                width={100}
                height={26}
              />
            </div>

            <img
              src="/images/message.svg"
              className="mb-3 mb-md-4 mx-auto"
              alt="message"
              width={124}
              height={124}
            />

            <h4 className="text-[20px] font-semibold mb-2">Success !</h4>

            <p className="mb-4">
              A email has been send to <strong>{data?.email}</strong>.<br />
              Please check for an email from EJAVEC and paste the activation code into form below
            </p>

            <div className="mb-4">
              <input
                type="hidden"
                name="email"
                value={data?.email || ""}
              />
              <input
                type="hidden"
                name="name"
                value={data?.name || ""}
              />
              <input
                onKeyUp={changeButtonState}
                type="text"
                name="kode_registrasi"
                className="input input-bordered w-full text-center h-[55px] text-dark"
                placeholder="Enter your activation code here"
              />
            </div>

            <button
              className="btn btn-primary btn-lg w-full"
              type="submit"
              disabled={buttonDisabled}
            >
              Activate My Account
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ConfirmEmailForm;
